import { Box, Button, Divider, Typography, useTheme } from '@mui/material';

type LogHeaderPropsT = {
  onCloseBtnClick?: () => void;
  onQueueDisplayBtnClick?: () => void;
};

function LogHeader({
  onCloseBtnClick: handleCloseBtnClick,
  onQueueDisplayBtnClick: handleQueueDisplayBtnClick,
}: LogHeaderPropsT) {
  const { palette } = useTheme();
  return (
    <>
      <Box
        sx={{
          backgroundColor: palette.background.paper,
          height: '44px',
          flex: '0 0 44px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="h5"
          color="white"
          align="center"
          sx={{ userSelect: 'none' }}
        >
          최근 기록
        </Typography>
        <Box
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            bottom: 0,
          }}
        >
          {handleCloseBtnClick && (
            <Button
              variant="text"
              onClick={handleCloseBtnClick}
              sx={{ px: '12px', minWidth: 0 }}
            >
              닫기
            </Button>
          )}
          {handleQueueDisplayBtnClick && (
            <Button
              variant="text"
              onClick={handleQueueDisplayBtnClick}
              sx={{ px: '12px', minWidth: 0 }}
            >
              호출
            </Button>
          )}
        </Box>
      </Box>
      <Divider />
    </>
  );
}

export default LogHeader;
